import { sessionState } from 'src/app/core/services/signal-state.storage';
import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Theme } from '../gdo-shared/Models/Models';
import { Route, Router } from '@angular/router';

@Component({
    selector: 'app-gdo-webview',
    templateUrl: './gdo-webview.component.html',
    styleUrls: ['./gdo-webview.component.scss'],
    standalone: false
})
export class GdoWebviewComponent implements OnInit {
  // theme: Theme = 'dark-theme';
  isAcura: boolean = false;

  constructor(
    private _appService: AppService,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router
  ) {
    
  }

  ngOnInit(): void {
    this._appService.setIsGdoPortal(true);
    this._appService.setViewViewStatus(true);
    // this.switchTheme();
  }

  switchTheme() {
    let vehicleData = sessionState.getItem("vehicleMake");
    if (vehicleData) {
      vehicleData = vehicleData.toLowerCase();
      if (vehicleData == 'acura') {
        this.isAcura = true;
      }
    }
    

    if (this.isAcura) {
      this.document.body.classList.add('dark-theme');
      this.document.body.classList.remove('light-theme');
    } else {
      this.document.body.classList.remove('dark-theme');
      this.document.body.classList.add('light-theme');
    }
  }
}
